const FEATURE_FLAGS = {
  COMPANY_EVENTS: "company-events",
  FR3028: "fr-3028",
  FR3342: "fr-3342",
  // Here starts new FF keys
  ABSENCES: "omb_absences",
  ORGANIZATION_STRUCTURE: "omb_organization-structure",
  ORGANIZATION_STRUCTURE_LOCALIZATIONS:
    "omb_organization-structure_localizations",
  ORGANIZATION_STRUCTURE_LOCALIZATIONS_EXPORT:
    "omb_organization-structure_export-localizations",
  ORGANIZATION_STRUCTURE_LOCALIZATIONS_IMPORT:
    "omb_organization-structure_import-localizations",
  ORGANIZATION_STRUCTURE_LOCALIZATIONS_IMPORT_EXPORT_TAB:
    "omb_organization-structure_import-export-localizations-tab",
  ORGANIZATION_STRUCTURE_LOCALIZATIONS_IMPORT_EXPORT_HISTORY:
    "omb_organization-structure_import-export-localizations-history",
  ORGANIZATION_STRUCTURE_POSITIONS: "omb_organization-structure_positions",
  ORGANIZATION_STRUCTURE_POSITIONS_EXPORT:
    "omb_organization-structure_export-positions",
  ORGANIZATION_STRUCTURE_POSITIONS_IMPORT:
    "omb_organization-structure_import-positions",
  ORGANIZATION_STRUCTURE_POSITIONS_IMPORT_EXPORT_TAB:
    "omb_organization-structure_import-export-positions-tab",
  ORGANIZATION_STRUCTURE_POSITIONS_IMPORT_EXPORT_HISTORY:
    "omb_organization-structure_import-export-positions-history",
  ORGANIZATION_STRUCTURE_IMPORT_EMPLOYEES:
    "omb_organization-structure_import-employees",
  ORGANIZATION_STRUCTURE_EXPORT_EMPLOYEES:
    "omb_organization-structure_export-employees",
  ORGANIZATION_STRUCTURE_IMPORT_EXPORT_EMPLOYEES_TAB:
    "omb_organization-structure_import-export-employees-tab",
  ORGANIZATION_STRUCTURE_IMPORT_AREAS:
    "omb_organization-structure_import-areas",
  ORGANIZATION_STRUCTURE_EXPORT_AREAS:
    "omb_organization-structure_export-areas",
  ORGANIZATION_STRUCTURE_IMPORT_EXPORT_AREAS_TAB:
    "omb_organization-structure_import-export-areas-tab",
  ORGANIZATION_STRUCTURE_SYNC_ERRORS: "omb_organization-structure_sync_errors",
  ORGANIZATION_STRUCTURE_REPORTS: "omb_organization-structure_reports",
  KNOWLEDGE_BASE: "omb_knowledge-base",
  KNOWLEDGE_BASE_SETTINGS: "omb_knowledge-base-settings",
  WALL: "omb_wall",
  DASHBOARD: "omb_dashboard-module",
  DASHBOARD_VISIBILITY: "omb_dashboard-module_visiblity",
  DASHBOARD_WIDGETS: "omb_dashboard-module_widgets",
  DASHBOARD_MENU_CONFIGURATION: "omb_dashboard-module_menu-configuration",
  DASHBOARD_EMPLOYEE_PROFILE: "omb_dashboard-module_employee-profile",
  DASHBOARD_MODULES_VISIBILITY_CONFIGURATION:
    "omb_dashboard-module_modules-visibility-configuration",
  PAYROLL_MODULE: "omb_payroll-module",
  DASHBOARD_IMPERSONATE: "omb_dashboard-module_impersonate",
  WALL_MODULE_SETTINGS: "omb_wall_module-settings",
  IMPERSONATED_USER_DETECTION: "omb_impersonated-user-detection",
  KUDOS: "omb_kudos",
  KUDOS_MODULE_SETTINGS: "omb_kudos_module-settings",
};

export default FEATURE_FLAGS;
